import React from 'react';
import styled, { css } from 'styled-components';
import ArrowIcon from '@catalogo/theme-svg/arrow.svg';

const Select = ({ onSelected, value, options }) => (
  <Container>
    <Arrow />
    <List onChange={e => onSelected(e.currentTarget.value)}>
      {options.map(option => (
        <Item key={option} selected={value === option && true} value={option}>
          {option}
        </Item>
      ))}
    </List>
  </Container>
);

export default Select;

const Container = styled.div`
  ${({ theme }) => css`
    width: 100%;
    font-size: ${theme.fontSize.sm};
    color: ${theme.grey.dark};
    position: relative;
    z-index: 2;
    border-bottom: 2px solid ${theme.grey.light};
    position: relative;
  `}
`;
const List = styled.select`
  ${({ theme }) => css`
    padding: 10px 0 10px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    cursor: pointer;
    z-index: 2;
    border-bottom: 2px solid ${theme.grey.light};
    border: 0;
    outline: 0;
    color: ${theme.grey.dark};
    font-size: ${theme.fontSize.sm};
    appearance: none;
    background-color: transparent;
  `}
`;
const Item = styled.option`
  ${({ theme }) => css`
    padding: 15px;
    cursor: pointer;
    background-color: ${theme.white};

    &:hover {
      background-color: #eee;
      color: ${theme.primaryColor};
    }
  `}
`;

const Arrow = styled(ArrowIcon)`
  ${({ theme }) => css`
    animation: all;
    width: 10px;
    height: 10px;
    pointer-events: none;
    transition: all 0.3s linear;
    fill: ${theme.grey.dark};
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%) rotate(-90deg);
  `}
`;
